import React, { Component } from 'react';
import styled from 'styled-components';
import media from './MediaQueries';
import { translate } from 'react-polyglot';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const StyledDiv = styled.div`
  ${media.phone`
    font-size: 20px;
    font-weight: 400;
  `}

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: 300;

  ul,
  li {
    list-style: none;
    z-index: 1;
  }
  li {
    color: white;
    text-align: center;
    margin-bottom: 1em;
  }
  .buttonStyle {
    margin-top: 75px;
  }
`;

const StyledAdditionalInfo = styled.div`
  font-size: 14px;
  width: 60%;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 20px;
  border-radius: 8px;
  position: absolute;
  left: 35%;
  top: 120px;
  color: white;
  max-height: 344px;
  overflow: auto;
  z-index: 1;
  border-radius: 20px 0px 20px 20px;

  ${media.phone`
    width: 79%;
    left: 15%;
    top: 120px;
    padding: 30px 20px;
    font-size: 12px;
    border-radius: 0px 20px 20px 20px;
  `}

  h1 {
    font-size: 18px;
    margin-bottom: 20px;
    ${media.phone`
      font-size: 14px;
    `}
  }

  li {
    margin-left: 18px;
    margin-bottom: 10px;
  }

  .closeModal {
    float: right;
    cursor: pointer;
    font-weight: bolder;
    position: absolute;
    top: 20px;
    right: 20px;
    text-align: right;
    width: 50px;
    height: 50px;
  }

  .warningText {
    margin-bottom: 10px;
  }
`;

class Introduction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAdditionalInfo: true,
    };
  }
  render() {
    const { options, t } = this.props;
    const { showAdditionalInfo } = this.state;

    const handleOnClick = () => {
      if (options.additionalInfo) {
        this.setState({ showAdditionalInfo: !showAdditionalInfo });
      }
    };

    return (
      <div>
        <StyledDiv className="revieve-introductionTexts" onClick={handleOnClick}>
          {options && options.texts ? (
            <ul>
              {options.texts.map((text, i) => (
                <li key={'introduction' + i}> {t(text)} </li>
              ))}
            </ul>
          ) : (
            <ul>
              <li>{t('build_skin_profile')}</li>
              <li>{t('take_selfie')}</li>
              <li>{t('see_skin_analysis')}</li>
              <li>{t('get_personal_advice')}</li>
              <li>{t('get_product_recommendations')}</li>
            </ul>
          )}
        </StyledDiv>
        <ReactCSSTransitionGroup
          transitionName="footerSlide"
          transitionAppear={true}
          transitionEnter={true}
          transitionLeave={true}
          transitionAppearTimeout={900}
          transitionLeaveTimeout={900}
          transitionEnterTimeout={900}
        >
          {options.additionalInfo && showAdditionalInfo && (
            <StyledAdditionalInfo className="revieve-additional-info">
              <div
                className="closeModal"
                onClick={e => {
                  e.stopPropagation();
                  handleOnClick();
                }}
              >
                X
              </div>
              <ul>
                {options.additionalInfo.map((text, i) => (
                  <li key={'additionalInfo' + i}> {t(text)} </li>
                ))}
              </ul>
            </StyledAdditionalInfo>
          )}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default translate()(Introduction);



// WEBPACK FOOTER //
// ./src/components/instore/Introduction.js